<template>
  <div class="user">
    <div v-if="route.path == '/meetings'">
      <MeetingAuth @authorized="getContent"></MeetingAuth>
    </div>

    <b-loading :is-full-page="true" :active="!moved && (route.path != '/meetings' && route.path != '/meetings/post-event-survey' && !meetingProfile)"></b-loading>
    <!-- Diplays the custom HTML template including a placeholder div for the content -->
    <div v-html="fullHtml"></div>

    <!-- An example component that gets loaded into the custom HTML template -->
    <div id="meeting-content" class="is-hidden">
      <MeetingSteps v-if="route.path != '/meetings/confirmation' && route.path != '/meetings/post-event-survey' "></MeetingSteps>
      <div v-if="this.meetingInfo">
        <b-notification v-if="route.path != '/meetings/confirmation' && route.path != '/meetings/post-event-survey' && this.meetingInfo.pnrRecordLocator" type="is-warning is-light" style="width: 100%; max-width: 100%; margin: auto" class="mb-5">
          <p class="is-size-5 mb-2">Your reservation number is {{ this.meetingInfo.pnrRecordLocator }}</p>
          <p>To modify or cancel your booking please contact Gant Travel for agent assistance at  877-924-0303 or <a href="mailto:travelsupport@ganttravel.com">travelsupport@ganttravel.com</a>.</p>
        </b-notification>
      </div>

      <router-view></router-view>
    </div>
    <!-- <span v-html="meetingInfo.meeting.customWebTemplate.body" v-css="meetingInfo.meeting.customWebTemplate.css"></span> -->

    <div class="has-text-centered is-centered is-size-7 py-3 has-text-grey-light">
      TripCircuit App Version {{ $store.getters['app/appVersion'] }}

      <a v-on:click.stop="$app.getCurrentAppVersion()" class="is-inline-block ml-1 has-text-grey-light">Check for updates</a>

      <div v-if="!$store.getters['app/appVersionsMatch']" class="mt-3 has-text-grey is-size-7">
          A newer version of TripCircuit is available. <br><a v-on:click.stop="$app.refreshBrowser()" class="is-inline-block">Load the new version</a> (Note: You will be logged out during this process)
      </div>
    </div>
  </div>
</template>

<script>
  import MeetingAuth from './Authorization.vue';
  import MeetingSteps from './MeetingSteps.vue';
  import meetingsMixin from "@/mixins/meetingsMixin";

  export default {
    name: 'Meetings',
    mixins: [meetingsMixin],
    components: {
      MeetingAuth,
      MeetingSteps
    },
    data: function () {
      return {
        logged_in: false,
        email: "",
        password: "",
        access_token: "",
        wrong: false,
        loading: false,
        beforeHtml: '',
        afterHtml: '',
        fullHtml: '',
        moved: false
      }
    },
    computed: {
      meetingProfile(){
        return this.$store.getters['travellersAndTrips/getCurrentTravellerProfile'];
      },
      meetingFlightResult() {
        return this.$route.name == 'MeetingsFlightsResults'
      },
      route(){
        return this.$route
      },
      dynamicTemplate(){
        if (!this.meetingInfo){
          return ''
        }
        else{
          return {template: this.meetingInfo.meeting.customWebTemplate.body.replace('[body content]', '<router-view></router-view>')}
        }
      }
    },
    methods: {
      loadCss () {
        // This now loads a dynamically generated stylesheet
        // Just pass in a customWebTemplateId that is found in the meeting details
        let file = document.createElement('link');
        file.rel =  'stylesheet';
        file.href = 'https://api.huddlelabs.com/custom-template/'+ this.customWebTemplateId +'/css';
        document.head.appendChild(file);
      },
      loadJavascript () {
        // This now loads a dynamically generated javascript file
        // Just pass in a customWebTemplateId that is found in the meeting details
        let script = document.createElement('script');
        script.src = 'https://api.huddlelabs.com/custom-template/'+ this.customWebTemplateId +'/javascript';
        script.async = true;
        document.body.appendChild(script);
      },
      moveMeetingContentIntoTemplate () {
        // Get the meeting content element
        let meetingContent = document.getElementById('meeting-content');
        // Remove the hidden class so it can be shown
        meetingContent.classList.remove('is-hidden');
        // Move to the placeholder element in the custom template
        document.getElementById('meeting-content-container').appendChild(meetingContent);
      },
      async getContent() {
        {
          console.log('loading content....')
          this.customWebTemplateId = this.meetingInfo.meeting.customWebTemplateId;
          this.beforeHtml = this.meetingInfo.meeting.customWebTemplate.beforeHtml;
          this.afterHtml = this.meetingInfo.meeting.customWebTemplate.afterHtml;
          this.fullHtml = this.beforeHtml + '<div id="meeting-content-container"></div>' + this.afterHtml;

          await this.loadCss();
          await this.loadJavascript();
          this.moveMeetingContentIntoTemplate();
          this.moved = true
        }
      }
    },
    created() {

      //this.baseaccount = this.$route.params.baseaccount;
    },
    mounted () {
      if (this.route.path != '/meetings') {
        this.getContent();
      }
      else{
        this.$app.logout();

        this.$app.getCurrentAppVersion();
        this.$app.reloadApp();

        // Get list of vendors
        this.$app.huddleLabsServerCall('resources/vendors')
            .then(result => {
              // console.log(result);
              this.$store.dispatch('bookTravel/vendors', result)
            });

        this.$app.huddleLabsServerCall('resources/airports?mode=advanced')
            .then(result => {
              let airports = result.data;
             //  console.log(airports);
              this.$store.dispatch('bookTravel/airports', airports)
            });
      }

      // Check for token in the URL parameter and convert to usable access_token
      var ssoToken = this.$route.query.token

      if (ssoToken) {

        // Set the secret key/salt to remove from the start of the token
        var tokenSalt = 'ehENoUSO'

        // base64_decode the token
        var decoded = atob(ssoToken)

        // Remove the secret key/salt to leave only the real access token
        var accessToken = decoded.replace(tokenSalt, '')

        // Check if the access token is valid
        this.checkAccessToken(accessToken)

      }
    },
}

</script>

<style scoped>
  .image{
    padding: 15px;
    padding-right: 20px;
  }
  .trip {
    color: #292C58;
    font-family: Krungthep;
    font-size: 50px;

  }
  .circuit {
    color: #00AA9C;
    font-family: Krungthep;
    font-size: 50px;

  }
  .text-center {
    text-align:center;
  }
  .centered {
    margin: auto;
  }
  .field {
    border-radius: 5px;
  }
  .wdt {
    width: 500px;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
  .register {
    background-color: #ddd;
    /* background-color: #F5F0E1; */
    border-radius: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .conditions {
    font-size: 13px;
    color: #292C58;
  }
  .btn {
    background-color: #292C58;
  }
  .shdw {
    box-shadow: 0 2px 4px 0 rgba(245,240,225, 0.8), 0 6px 20px 0 rgba(245,240,225, 0.8);
    border-radius: 5px;
  }
  .fade {
    opacity: 0.5;
    transition: opacity .05s ease-in-out;
    -moz-transition: opacity .05s ease-in-out;
    -webkit-transition: opacity .05s ease-in-out;
  }
  .fade:hover {
    opacity: 1;
  }
  @media screen and (max-width: 1023px) {
    .wdt {
      width: 100%;
      margin: auto;
      /* background-color: #F5F0E1; */
    }
  }
  @media screen and (min-width: 1024px) {
    .wdt {
      width: 500px;
      margin: auto;
      /* background-color: #F5F0E1; */
    }
  }
</style>
